import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    return function (_ctx, _cache) {
      var _component_a_input = _resolveComponent("a-input");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfExamNo.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "考生考号：",
            name: "examNo"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input, {
                allowClear: "",
                maxlength: 20,
                size: "large",
                value: _unref(formState).examNo,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).examNo = $event;
                }),
                placeholder: "考生考号"
              }, null, 8, ["value"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});